<template>
  <div class="container">
    <Title-b title="自提點查詢" />
    <div class="all">
      <div class="search">
        <i-input
          placeholder=""
          v-model="searchValue"
          style="width: 343px"
        ></i-input>
        <i-button
          type="error"
          class="search_error"
          @click="GetAllZtd"
          style="color: #fff"
          >自提點查詢</i-button
        >
        <img src="../../../assets/images/sousuo1.png" alt="" />
      </div>
      <div class="from">
        <div>
          <span class="span">自提點篩選：</span>
          <i-select
            v-model="addressid.Country"
            placeholder="請選擇國家"
            @on-change="changeAddress('Country', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemm.CountryID"
              v-for="(itemm, indexx) in syck"
              :key="indexx"
            >
              {{ itemm.CountryName }}
            </i-option>
          </i-select>
          <i-select
            v-model="addressid.Provice"
            placeholder="請選擇省"
            @on-change="changeAddress('Provice', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemm.CodeID"
              v-for="(itemm, indexx) in addList.Country"
              :key="indexx"
            >
              {{ itemm.Name }}
            </i-option>
          </i-select>
          <!-- 第二个 -->
          <i-select
            v-model="addressid.City"
            placeholder="請選擇市"
            @on-change="changeAddress('City', $event)"
            style="width: 105px"
          >
            <i-option
              :value="item.CodeID"
              v-for="(item, index) in addList.Provice"
              :key="index"
            >
              {{ item.Name }}
            </i-option>
          </i-select>
          <!-- 第三个 -->
          <i-select
            v-model="addressid.Area"
            placeholder="請選擇"
            @on-change="changeAddress('Area', $event)"
            style="width: 105px"
          >
            <i-option
              :value="itemmm.CodeID"
              v-for="(itemmm, indexxx) in addList.City"
              :key="indexxx"
            >
              {{ itemmm.Name }}
            </i-option>
          </i-select>
        </div>
      </div>
      <div class="address-wrapper">
        <div class="address-item" v-for="(item, index) in allorder" :key="index" >
          <div class="a-title">{{ item.Address }}</div>
          <!-- <div class="a-address">{{item.Address}}</div> -->
          <div> 聯絡人：{{ item.link_man }}
            <span class="a-tel">聯絡電話：{{ item.Tel }}</span>
            <span class="a-tel">聯系手機：{{ item.Phone }}</span>
          </div>
          <div class="a-time">營業時間：{{ item.Business_time }}</div>
          <div> 最大限重：{{ item.MaxWeight }} , 是否支持到付： {{ item.IsDfDescption }}</div>
          <div class="a-link">
            <img class="a-img" src="@/assets/images/dizhzi.png" alt="" />
            {{ item.Name }}
          </div>
          <div>
            {{item.IsDefault == false?'设为默认地址':(item.IsDefault == true?'默认地址':'设为默认地址')}}
            <i-switch  v-model="item.IsDefault" true-color="#7966fe" false-color="#dcdee0"  @on-change="defaddress(item, $event)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      allorder: [],
      arr: [],
      searchValue: "",
      addList: {
        Provice: [],
        City: [],
        Area: [],
        Country: [],
      },
      addressid: {
        Country: 0,
        Provice: 0,
        City: 0,
        Area: 0,
      },
      syck: [],
    };
  },
  methods: {
    // 设置默认地址
    async defaddress(item){
      let that = this;
      that.actvue = item
      console.log(that.actvue,'index')
       const JsonData = {
        MemberID: localStorage.getItem("userID"),
        ZtdID:that.actvue.ID,
      };
      console.log(JsonData,'js')
      const {data} = await this.$post('Edit_DefaultAddress',JsonData)
      if(data.State== true){
        that.actvue.IsDefault = true
      }
        // console.log(data,'data')
    },
    // 查询默认地址
    async inqaddress(){
      const JsonData = {
        MemberID: localStorage.getItem("userID"),
      };
      console.log(JsonData,'js')
      const {data} = await this.$post('Query_DefaultAddress',JsonData)
        console.log(data,'data')
        this.GetAllZtd()
    },
    async getCountryList() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("GetCountryList", params);
      if (data.State) {
        this.syck = JSON.parse(data.ReturnJson);
      }
    },
     async GetAllZtd2() {
      const { data } = await this.$post("QueryZtd", this.addressid);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
      }
    },
    // 省市区
    async changeAddress(key, e) {
      switch (key) {
        case "Country":
          this.addList.Provice = [];
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.Provice = 0;
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "Provice":
          this.addList.City = [];
          this.addList.Area = [];
          this.addressid.City = 0;
          this.addressid.Area = 0;
          break;
        case "City":
          this.addList.Area = [];
          this.addressid.Area = 0;
          break;
      }
      this.addressid[key] = e;
      const params = {
        ParentID: key == "Country" ? 0 : e,
        CountryID: this.addressid.Country,
      };
      this.GetAllZtd2()
      const { data } = await this.$post("GetAreaByParentID", params);
      if (data.State) {
        this.addList[key] = JSON.parse(data.ReturnJson);
      }
    },
    async GetAllZtd() {
      let _this = this;
      const { data } = await this.$post("GetAllZtd", {
        ZtdName: this.searchValue,
        MemberID: localStorage.getItem("userID"),
        Country:this.addressid.Country,
        Provice:this.addressid.Provice,
        City:this.addressid.City,
        Area:this.addressid.Area
      });
      if (data.State) {
        
        this.allorder = JSON.parse(data.ReturnJson);
      }
    },
  },
  mounted() {
    this.getCountryList();
    this.GetAllZtd();
    this.inqaddress()
  },
};
</script>
<style lang="scss" scoped>
.container {
  overflow:auto;
  width: 1069px;
  height: 748px;
  background: #fff;
  padding: 20px 29px;
  .from { 
    margin: 0px auto 20px;
  }
  .address-wrapper {
    .address-item {
      margin-bottom: 20px;
      display: inline-block;
      vertical-align: top;
      width: 50%;
      line-height: 40px;
      .a-title {
        @include color($_color);
        font-size: 18px;
        font-weight: bold;
      }
      .a-address {
        font-size: 16px;
      }
      .a-tel {
        @include color($_color);
        margin-left: 20px;
      }
      .a-link {
        @include color($_color);
        cursor: pointer;
        .a-img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  // 修改table的属性
  /deep/ #mygrid {
    width: 1029px;
    .ivu-table th {
      text-align: center;
      background: #e2e2e2;
    }
    .ivu-table td {
      text-align: center;
      height: 30px;
    }
    // .ivu-table tr:nth-child(odd){
    //   background-color: red;
    // }
    // .ivu-table tr:nth-child(even){
    //   background-color: #000;
    // }
  }
  .userP {
    color: #ccc;
    font-size: 14px;
    font-weight: 400;
    padding: 15px 0 0 61px;
  }

  .all {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 1000px;

    .search {
      height: 52px;
      margin: 20px 0 0 265px;
      position: relative;
      .search_error {
        width: 120px;
        height: 30px;
        //  @include border($_color);
        @include backgroundColor($_color);
        // background: #FF0000;
        color: #fff;
        margin-left: 10px;
      }
      /deep/ .ivu-btn-error {
        border-color: #fff;
      }

      /deep/ .ivu-input {
        padding-left: 39px !important;
      }
      /deep/ .ivu-input::-webkit-input-placeholder {
        color: #999;
        padding-left: 30px;
      }
      img {
        position: absolute;
        left: 13px;
        top: 6px;
      }
    }
    .date {
      width: 1029px;
      margin: 30px 0 0 -9px;
      border: 1px solid #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/pick.vue